import React, { useState, useEffect } from 'react';

const ScrollToTopButton = ({ showThreshold = 300 }) => {
    const [isVisible, setIsVisible] = useState(false);

    useEffect(() => {
        const toggleVisibility = () => {
            if (window.pageYOffset > showThreshold) {
                setIsVisible(true);
            } else {
                setIsVisible(false);
            }
        };

        // Add scroll listener
        window.addEventListener('scroll', toggleVisibility, { passive: true });

        // Cleanup
        return () => {
            window.removeEventListener('scroll', toggleVisibility);
        };
    }, [showThreshold]);

    const scrollToTop = () => {
        window.scrollTo({
            top: 0,
            behavior: 'smooth'
        });
    };

    return (
        <button
            className={`scroll-to-top-button ${isVisible ? 'visible' : 'hidden'}`}
            onClick={scrollToTop}
            aria-label="Tillbaka till toppen"
            title="Tillbaka till toppen"
        >
            <svg 
                width="20" 
                height="20" 
                viewBox="0 0 24 24" 
                fill="none"
                stroke="currentColor" 
                strokeWidth="2" 
                strokeLinecap="round" 
                strokeLinejoin="round"
            >
                <path d="M18 15l-6-6-6 6"/>
            </svg>
        </button>
    );
};

export default ScrollToTopButton;
